import { render, staticRenderFns } from "./domaine-lignier-michelot.vue?vue&type=template&id=85fc678c&scoped=true"
import script from "./domaine-lignier-michelot.vue?vue&type=script&lang=js"
export * from "./domaine-lignier-michelot.vue?vue&type=script&lang=js"
import style0 from "./domaine-lignier-michelot.vue?vue&type=style&index=0&id=85fc678c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fc678c",
  null
  
)

export default component.exports